<template>
  <ul v-if="contragent" class="c-company-card">
    <li class="c-company-card__line">
      <h3 class="c-company-card__subtitle">Наименование:</h3>
      <div class="c-company-card__info">
        <p class="c-text">{{ contragent.org_name }}</p>
      </div>
    </li>
    <li class="c-company-card__line">
      <h3 class="c-company-card__subtitle">
        ИНН<template v-if="extraParamsIsLoad"> / ОГРН</template>:
      </h3>
      <!-- /ОГРН -->
      <div class="c-company-card__info">
        <p class="c-text">
          {{ contragent.inn }}
          <template v-if="extraParamsIsLoad"> / {{ extra.ogrn }}</template>
        </p>
      </div>
    </li>
    <li class="c-company-card__line">
      <h3 class="c-company-card__subtitle">Контакты:</h3>
      <div class="c-company-card__info">
        <p class="c-text">{{ contragent.phone }}</p>
        <!--   - Зайцев Игорь Александрович -->
      </div>
    </li>
    <li
      v-if="propsIsValid('name_bank')"
      class="c-company-card__line c-company-card__line--flex"
    >
      <h3 class="c-company-card__subtitle">Банк:</h3>
      <div class="c-company-card__info">
        <p class="c-text">
          {{ contragent.name_bank }}
          <template v-if="contragent.checking_account">
            <br />Расчётный счёт {{ contragent.checking_account }}
          </template>
          <template v-if="contragent.core_account">
            <br />Корреспондентский счёт
            {{ contragent.core_account }}
          </template>
          <template v-if="contragent.bik">
            <br />БИК {{ contragent.bik }}
          </template>
        </p>
      </div>
    </li>
    <li v-if="autos.length" class="c-company-card__line">
      <h3 class="c-company-card__subtitle">Автомобили:</h3>
      <div class="c-company-card__info">
        <ul class="c-company-card__list">
          <li v-for="auto in autos" :key="auto.id" class="c-company-card__item">
            <div class="c-text">
              <span>
                {{ auto.state_numbers }} - автомобиль
                <span v-aprroveStatusText="checkMasterApprove(auto)" />
                системой
              </span>
              <!-- <el-popover
					class="c-company-card__hint"
					placement="top-start"
					width="200"
					trigger="click"
					content="Текст подсказки, длинною в несколько предложений"
				>
					<span slot="reference">
					<i class="el-icon-question"></i>
					</span>
				</el-popover> -->
              <br />
              <a
                href="#"
                class="c-company-card__link"
                @click.prevent="getZip(auto.state_numbers, auto.id, 'autos')"
              >
                скачать документы
              </a>
            </div>
          </li>
        </ul>
      </div>
      <!--<a
			href
			class="c-company-card__link"
			download
			:class="{ 'el-button el-button--primary': clientWidth }"
		>скачать документы по всем автомобилям одним архивом</a>-->
    </li>
    <li v-if="drivers.length" class="c-company-card__line">
      <h3 class="c-company-card__subtitle">Водители:</h3>
      <div class="c-company-card__info">
        <ul class="c-company-card__list">
          <li
            v-for="driver in drivers"
            :key="driver.id"
            class="c-company-card__item"
          >
            <div class="c-text">
              <span>
                {{ driver.fio }} - водитель
                <span v-aprroveStatusText="checkMasterApprove(driver)" />
                системой
              </span>
              <br />
              <a
                href="#"
                class="c-company-card__link"
                @click.prevent="getZip(driver.fio, driver.id, 'drivers')"
              >
                скачать документы
              </a>
            </div>
          </li>
        </ul>
      </div>
      <!--<a
			href
			class="c-company-card__link"
			download
			:class="{ 'el-button el-button--primary': clientWidth }"
		>скачать документы по всем водителям одним архивом</a>-->
    </li>

    <contracts-list :contract="contragent.contract || {}" />
  </ul>
</template>
<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { loadError } from '@/datas/Messages'
import ContractsList from '../../components/Contracts/ContractsList'

const Check = RepositoryFactory.get('check')
const DocumentRepository = RepositoryFactory.get('document')
const Auto = RepositoryFactory.get('auto')
const Driver = RepositoryFactory.get('driver')
const EXPAND = 'expand=master-approve'
const FILTER = 'carrier_inn'

export default {
  name: 'CompanyCard',
  components: { ContractsList },
  directives: {
    aprroveStatusText(el, binding) {
      let innerHTML = 'проверен'
      let fontWeight = 300

      if (!binding.value) {
        innerHTML = '<b>не проверен</b>'
        fontWeight = 600
      }
      el.innerHTML = innerHTML
      el.style.fontWeight = fontWeight
    },
  },
  props: {
    contragent: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      clientWidth: false,
      autos: [],
      drivers: [],
      extra: {},
    }
  },
  computed: {
    extraParamsIsLoad() {
      return 'ogrn' in this.extra && this.extra.ogrn
    },
    checkMasterApprove() {
      return propName =>
        Object.prototype.hasOwnProperty.call(propName, 'master-approve') &&
        Object.prototype.toString.call(propName['master-approve']) ===
          '[object Object]' &&
        Number(propName['master-approve'].status) === 1
    },
    propsIsValid() {
      return propName =>
        Object.prototype.hasOwnProperty.call(this.contragent, propName) &&
        this.contragent[propName]
    },
  },
  watch: {
    contragent: {
      immediate: true,
      handler(value) {
        if (value?.inn) {
          this.clearParams()
          this.init()
        }
      },
    },
  },
  created() {
    window.addEventListener('resize', this.onClientWidth)
    this.onClientWidth()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onClientWidth)
    this.clearParams()
    this.$emit('clear-contragent')
  },
  methods: {
    getZip(documentName, id, entityName) {
      let filename

      switch (entityName) {
        case 'autos':
          filename = 'Документы по авто '
          break
        case 'drivers':
          filename = 'Документы по водителю '
          break
      }
      filename += `${documentName}.zip`
      this.getZipRequest(entityName, id, filename)
    },
    getZipRequest(source, id, filename) {
      DocumentRepository.getZipByLink(source, id)
        .then(response => {
          this.forceFileDownload(response, filename)
        })
        .catch(() => this.$alert('Нет файлов для скачивания'))
    },
    onClientWidth() {
      return (this.clientWidth = document.documentElement.clientWidth < 992)
    },
    async loadExtraData() {
      try {
        let payload = `${FILTER}=${this.contragent.inn}`
        let autos = await Auto.findAutoByCarrierInn(payload, EXPAND)
        let drivers = await Driver.findDriverByCarrierInn(payload, EXPAND)
        let additional = await Check.inn(this.contragent.inn)

        return Promise.all([autos, drivers, additional])
      } catch (e) {
        this.errHandler(loadError)
      }
    },
    async init() {
      let {
        0: {
          data: { items: autos },
        },
        1: {
          data: { items: drivers },
        },
        2: { data: extra },
      } = await this.loadExtraData()

      this.autos = autos
      this.drivers = drivers
      this.extra = extra
    },
    clearParams() {
      this.autos.length = 0
      this.drivers.length = 0
      this.extra = {}
    },
  },
}
</script>

<style lang="scss">
.c-company-card {
  word-break: break-word;
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-family: 'Rubik', Arial, sans-serif;

  &__line {
    margin-bottom: 29px;

    &:last-child {
      margin-bottom: 0;
    }

    &--flex {
      //display: flex;

      .c-company-card__subtitle {
        margin-right: 30px;
      }
    }
  }

  &__subtitle {
    margin: 0 0 10px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #b7b7b7;
  }

  &__info {
    .c-text {
      &:last-child {
        margin: 0;
      }
    }
  }

  &__list {
    list-style-type: none;
    padding: 0;
    margin: 0 0 20px;
  }

  &__item {
    //display: flex;
    margin-bottom: 20px;
    word-break: break-word;

    &:last-child {
      margin-bottom: 0;
    }

    .c-text {
      margin-right: 35px;
      word-break: break-word;
    }
  }

  &__hint {
    margin-left: 5px;
    cursor: pointer;
  }

  &__link {
    font-size: 16px;
    line-height: 19px;
    color: #3498db;
    text-decoration: underline;

    &.el-button {
      max-width: 100%;
      color: #ffffff;
      text-decoration: none;
      white-space: normal;
      word-break: break-word;
    }
  }
}

.c-hint {
  display: flex;

  &__wrapper {
    position: relative;
  }

  &__toggler {
    flex-basis: 28px;
    margin-left: 10px;
  }

  &__body {
    position: absolute;

    display: none;
  }
}

.c-text {
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
}

@media (min-width: 992px) {
  .c-company-card {
    &__line {
      margin-bottom: 29px;

      &:last-child {
        margin-bottom: 0;
      }

      &--flex {
        display: flex;

        .c-company-card__subtitle {
          margin-right: 30px;
        }
      }
    }

    &__item {
      display: flex;
    }
  }
}
</style>
